<div class="login-container">
    <form [formGroup]="createPasswordForm">
        <img src="./assets/images/logo-bo-new-gen.png" alt="" height="32" width="109">
        <div class="box-center">
          <span class="title">ตั้งค่ารหัสผ่านใหม่</span>
          <span class="sub-title">กรุณากรอกรหัสผ่านใ้ห้ถูกต้อง</span>
        </div>
        <div class="not-match" *ngIf="checkValidate('passwordNotMatch')">
          <div>
            <span><img src="/assets/images/icon-valid.png" alt="" height="16" width="16"></span>
            รหัสผ่านไม่ตรงกัน  กรุณากรอกรหัสผ่านใหม่อีกครั้ง
          </div>
        </div>
      <div class="form-group">
        <label for="password">รหัสผ่าน</label>
        <div class="password-input-container">
          <input id="password" formControlName="password" [type]="isPasswordVisible ? 'text' : 'password'"
            placeholder="กรอกรหัสผ่าน" />
          <mat-icon class="password-toggle-icon" (click)="togglePasswordVisibility('password')">
            {{ isPasswordVisible ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>
      <div class="form-group">
        <label for="confirmPassword">ยืนยันรหัสผ่าน</label>
        <div class="password-input-container">
          <input id="password" formControlName="confirmPassword" [type]="isConfirmPasswordVisible ? 'text' : 'password'"
            placeholder="กรอกรหัสผ่าน" />
          <mat-icon class="password-toggle-icon" (click)="togglePasswordVisibility('confirmPassword')">
            {{ isConfirmPasswordVisible ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </div>
      </div>
  
      <div class="check-valid">
        <h1>ข้อกำหนดรหัสผ่าน</h1>
        <p><span>
          <img *ngIf="!checkValidate('length')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
          <img *ngIf="checkValidate('length')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
        </span>มีความยาว 8 ตัวอักษรขึ้นไป</p>
        <p><span>
          <img *ngIf="!checkValidate('az')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
          <img *ngIf="checkValidate('az')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
        </span>มีตัวอักษรพิมพ์เล็ก (a-z) อย่างน้อย 1 ตัว</p>
        <p><span>
          <img *ngIf="!checkValidate('AZ')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
          <img *ngIf="checkValidate('AZ')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
        </span>มีตัวอักษรพิมพ์ใหญ่ (A-Z) อย่างน้อย 1 ตัว</p>
        <p><span>
          <img *ngIf="!checkValidate('num')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
          <img *ngIf="checkValidate('num')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
        </span>มีตัวเลข (0-9) อย่างน้อย 1 ตัว</p>
        <p><span>
          <img *ngIf="!checkValidate('noSpecialChar')" src="./assets/images/icon-checkbox-empty.png" alt="" height="16" width="16">
          <img *ngIf="checkValidate('noSpecialChar')" src="./assets/images/icon-checkbox-checked-2.png" alt="" height="16" width="16">
        </span>ห้ามมีอักขระพิเศษ</p>
      </div>
  
      <button type="submit" class="btn btn-primary login-button" (click)="onSubmit()" [disabled]="disabledButton()">ยืนยัน</button>
    </form>
  </div>